export default __webpack_public_path__ + "static/media/capgemini.df047d1d.svg";